var render = function render(){var _vm=this,_c=_vm._self._c;return _c('set-password',{attrs:{"action":"/admin/set-password"},scopedSlots:_vm._u([{key:"backToLogin",fn:function(){return [_c('router-link',{attrs:{"to":{ name: 'admin-login' }}},[_vm._v("Sign In.")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }